import { Link } from 'react-router-dom';
import moment from 'moment';
import { Config, ICenter, IMovie } from '../interfaces';

declare const config: Config;

interface IFilmProps {
  film: IMovie;
  selectedCenter: ICenter | undefined;
  selectedLanguage: string;
  withDialog?: boolean;
}

const Film = ({ film, selectedCenter, selectedLanguage, withDialog }: IFilmProps) => {
  const centerId = selectedCenter?.winticketId;
  const getOptionalParams = () => {
    const params = new URLSearchParams();
    if (withDialog) {
      params.set('displayoption', 'dialog');
      params.set('closeurl', `${window.location.origin}/center/${centerId}/withdialog/film-list`);
    }
    const paramStr = params.toString() ? `?${params.toString()}` : '';
    return paramStr;
  };

  const getPerformanceLink = (performanceId: string) => {
    if (withDialog) {
      const params = new URLSearchParams({
        center: centerId!,
        language: selectedLanguage,
        page: 'seatingplan',
        performance: performanceId,
        displayoption: 'dialog',
        closeurl: `${window.location.origin}/center/${centerId}/withdialog/film-list`,
      });
      return `${config.apiService.webshop.endpoint}/landingpage?${params.toString()}`;
    } else {
      return `/center/${centerId}/seatingplan${getOptionalParams()}`;
    }
  };

  const formatPerformanceDate = (dateTime: string) => moment(dateTime).parseZone().format('DD.MM.YYYY');

  const formatPerformanceTime = (dateTime: string) => moment(dateTime).parseZone().format('HH:mm');

  return (
    <div className='film'>
      <div className='film-mobile'>
        <div className='film-mobile-header'>
          <img src={`${film.imageUrl}&size=270`} alt={`${film.name} - Poster`} className='film-mobile-poster' />
          <h2 className='film-mobile-title'>{film.name}</h2>
        </div>
        <hr className='film-separator' />
        <div className='film-performances-list'>
          {film.performances.map((performance) => (
            <div className='film-performance' key={performance.id}>
              <Link
                to={{
                  pathname: getPerformanceLink(performance.id),
                  state: { performance },
                }}
                target={withDialog ? '_top' : undefined}
              >
                <p>{formatPerformanceDate(performance.performanceDateTime)}</p>
                <p>{formatPerformanceTime(performance.performanceDateTime)}</p>
                <p>{performance.auditoriumName}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className='film-desktop'>
        <h2 className='film-title'>{film.name}</h2>
        <div className='film-info-wrapper'>
          <img src={`${film.imageUrl}&size=270`} alt={`${film.name} - Poster`} className='film-info-wrapper-img' />
          <div className='film-performances-list'>
            {film.performances.map((performance) => (
              <div className='film-performance' key={performance.id}>
                <Link
                  to={{
                    pathname: getPerformanceLink(performance.id),
                    state: { performance },
                  }}
                  target={withDialog ? '_top' : undefined}
                >
                  <p>{formatPerformanceDate(performance.performanceDateTime)}</p>
                  <p>{formatPerformanceTime(performance.performanceDateTime)}</p>
                  <p>{performance.auditoriumName}</p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Film;
